/**
 * Navigacio a SERVICE WORKER kereser - ujratoltes nelkul.
 *
 * Egy rendszer-ertesitesre kattintva a service worker mondja meg, hova kell
 * menni. A kezenfekvo megoldas a `client.navigate()` lenne, csakhogy az TELJES
 * oldalbetoltes: a lap ujraepul, es vele hal minden, ami a memoriajaban elt -
 * a folyo hivas LiveKit-kapcsolata, a valos ideju csatorna, a felig beirt
 * uzenet.
 *
 * Pontosan ez tortent egyszer: oleles kozben erkezett egy emlekezteto-
 * ertesites, es a ra kattintas kileptette a felhasznalot a hivasbol.
 *
 * Ezert a service worker most csak SZOL, hogy hova kellene menni, a
 * navigaciot pedig a kliens-oldali utvonalvalaszto vegzi el - ugyanugy, mint
 * amikor a felhasznalo az oldalsavban kattint. A lap nem toltodik ujra,
 * tehat nincs mit elveszteni.
 */

/** A csatorna-utvonal, ahogy a service worker kuldi: `/c/<id>?m=<uzenet>`. */
const CHANNEL_PATH = /^\/c\/([^/?#]+)(?:\?m=([^&#]+))?$/;
/** Bejovo hivas telefonon (K2): `/huddle/<csatorna>?hivas=1`. */
const CALL_PATH = /^\/huddle\/([^/?#]+)\?hivas=1$/;

export interface SwNavigation {
  channelId: string;
  /** Melyik uzenetre ugorjunk - permalink eseten. */
  messageId: string | undefined;
  /** Bejovo hivas: a hivas kepernyoje nyiljon, ne a csatorna. */
  call?: boolean;
}

/**
 * Feliratkozas a service worker navigacios kereseire.
 *
 * @returns a leiratkozo fuggveny.
 */
export function onServiceWorkerNavigate(handler: (target: SwNavigation) => void): () => void {
  if (typeof navigator === 'undefined' || !navigator.serviceWorker) return () => undefined;

  const listener = (event: MessageEvent) => {
    const data: unknown = event.data;
    if (!data || typeof data !== 'object') return;

    const frame = data as { type?: unknown; target?: unknown };
    if (frame.type !== 'avslack:navigate' || typeof frame.target !== 'string') return;

    /*
      A CIMET mi ertelmezzuk, nem a routerre bizzuk nyersen.

      Igy a lap sosem kap kivulrol egy tetszoleges utvonalat: csak azt az egy
      alakot fogadjuk el, amit a service worker kuldhet. Egy elirt vagy idegen
      cim nem vihet ismeretlen allapotba.
    */
    const call = CALL_PATH.exec(frame.target);
    if (call) {
      handler({ channelId: decodeURIComponent(call[1]!), messageId: undefined, call: true });
      return;
    }

    const match = CHANNEL_PATH.exec(frame.target);
    if (!match) return;

    handler({
      channelId: decodeURIComponent(match[1]!),
      messageId: match[2] ? decodeURIComponent(match[2]) : undefined,
    });
  };

  navigator.serviceWorker.addEventListener('message', listener);
  return () => navigator.serviceWorker.removeEventListener('message', listener);
}
